export default __webpack_public_path__ + "48ae7b8be5e0ad0449cacea73d03555c.woff";